<template>
  <v-data-table
    :headers="headers"
    :items="listaUsers"
    :page="page"
    :pageCount="numberOfPages"
    :options.sync="options"
    :server-items-length="totalRecords"
    :footer-props="{
        showFirstLastPage: true,
        'items-per-page-options': [10, 20, 50]
    }"
  >
    <template v-slot:item.status="{ item }">
      <v-chip
        :color="getColor(item.status)"
        pill
        dark
        class="status-column"
      >
        {{ item.status }}
      </v-chip>
    </template>

    <template v-slot:item.lastLoginDate="{ item }">
      {{item.lastLoginDate | formatDate}}
    </template>

    <template v-slot:item.actions="{ item }">

        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-icon
                    small
                    class="mr-2 star"
                    v-if='item.isAdmin'
                    v-bind="attrs" v-on="on"
                >
                    mdi-star
                </v-icon>
            </template>
            <span>{{$t('backoffice.modules-management.vrm.components.datatable-user.admin')}}</span>
        </v-tooltip>

        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <span class="mr-2 p-0 circle" @click="moduleEdit(item)" v-bind="attrs" v-on="on">
                    <img src="/images/_SVGs/bo/lista-modulos.svg" onload="SVGInject(this)" width="12" height="12" style="margin-left:4px;"/>
                </span>
            </template>
            <span>{{$t('backoffice.modules-management.vrm.components.datatable-user.modules-list')}}</span>
        </v-tooltip>

        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <span class="mr-2 p-0 circle"  @click="userEdit(item)" v-bind="attrs" v-on="on">
                    <img src="/images/_SVGs/bo/edit_pencil.svg" class="circle" onload="SVGInject(this)" width="12" height="12" />
                </span>
            </template>
            <span>{{$t('backoffice.modules-management.vrm.components.datatable-user.edit-user')}}</span>
        </v-tooltip>

    </template>
  </v-data-table>
</template>

<script>
  export default {
    props: {
      listaUsers: Array | Object,
      searchCount: Number,
      totalRecords: Number
    },
    data () {
      return {
        headers: [
          { text: this.$t('backoffice.general.name'), value: 'name',class: 'header-table-color' },
          { text: this.$t('backoffice.general.company'), value: 'company',class: 'header-table-color' },
          { text: this.$t('backoffice.general.email'), value: 'email',class: 'header-table-color' },
          { text: this.$t('backoffice.general.phone'), value: 'phone',class: 'header-table-color' },
          { text: this.$t('backoffice.general.last-login'), value: 'lastLoginDate', align: 'center',class: 'header-table-color' },
          { text: this.$t('backoffice.general.status'), value: 'status' , align: 'center',class: 'header-table-color' },
          { text: '', value: 'actions', sortable: false, align: 'right',class: 'header-table-color' },
        ],
        page: 1,
        numberOfPages:0,
        options: {
          page: 1,
          itemsPerPage: 10
        },
      }
    },
    watch: {
      "options.page": {
        handler() {
          this.$emit('alterTable', this.options);
        },
      },
      "options.itemsPerPage": {
        handler() {
          this.$emit('alterTable', this.options);
        },
      },
      searchCount:{
        handler() {
          this.options.page = 1
        },
      },
      deep: true,
    },
    methods: {
      getColor (status) {
        if (status == this.$t('backoffice.general.active-status')) return 'green'
        else if (status == this.$t('backoffice.general.inactive-status')) return 'red'
        else return 'orange'
      },
      moduleEdit(item){
        this.$router.push({ name: 'backoffice-users-edit-modules', params: { id: item.id }})
      },
      userEdit(item){
        this.$emit('on-click-edit-user', item);
      },
    },
  }
</script>

<style lang="scss">
    @import '@sass/_variables.scss';
    #content-backoffice{
        table{
            thead{
                tr{
                    th{
                        border: 0;
                        
                        &.header-table-color{
                            background-color: #F2F2F2 !important;
                            color:#9E9D9D !important;
                            font-weight: 500;
                        }
                    }
                }
            }
            tbody{
                tr{
                    td{
                        font-size: 12px;
                        border: 0;
                    }
                }
            }

        }
        .status-column{
            width: 100%;
            margin: 0 auto;
            text-align: center;
            .v-chip__content{
                margin: 0 auto;
                text-align: center;
                font-size: 12px;
            }
        }
        .row-services{
            width: 100px;
            margin: 0 auto;
            .services {
                height: 14px !important;
                width: 14px !important;
                border-radius: 50% !important;
                font-size: 12px !important;
                padding: 2px;
            }
        }

        .circle{
            background-color: #E6E5E5;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            display: -webkit-inline-box;
            cursor:pointer;
        }
        .star{
            color: $star-backoffice!important;
        }

            .v-data-footer {
                margin-right: 40px !important;
            }
    }

</style>
